"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var md_1 = require("react-icons/md");
var react_use_1 = require("react-use");
var constant_1 = require("../../../constant");
var icons_1 = require("../../../icons");
var withLabel_1 = require("../../InputLabel/withLabel");
var layout_1 = require("../../layout");
var Input_1 = __importDefault(require("../Input/"));
var styles_1 = require("./styles");
var SIZES = {
    small: {
        controlsWidth: 20,
        icon: 12,
    },
    default: {
        controlsWidth: 22,
        icon: 12,
    },
    large: {
        controlsWidth: 22,
        icon: 12,
    },
};
var Before = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var style = react_2.useMemo(function () { return styles_1.getStyle(disabled); }, [disabled]);
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", onClick: onClick, className: "controlButton", css: [style.iconStyle, style.before] },
        react_1.jsx(md_1.MdRemove, null)));
};
var Up = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c;
    var style = react_2.useMemo(function () { return styles_1.getStyle(disabled); }, [disabled]);
    return (react_1.jsx("button", { disabled: disabled, onClick: onClick, className: "controlButton", css: [style.controlBtn, style.iconStyle, style.up] },
        react_1.jsx(icons_1.ChevronUp, { size: SIZES[size].icon })));
};
var Down = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c;
    var style = react_2.useMemo(function () { return styles_1.getStyle(disabled); }, [disabled]);
    return (react_1.jsx("button", { disabled: disabled, onClick: onClick, className: "controlButton", css: [style.controlBtn, style.iconStyle, style.down] },
        react_1.jsx(icons_1.ChevronDown, { size: SIZES[size].icon })));
};
var After = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var style = react_2.useMemo(function () { return styles_1.getStyle(disabled); }, [disabled]);
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", onClick: onClick, className: "controlButton", css: [style.iconStyle, style.after] },
        react_1.jsx(md_1.MdAdd, null)));
};
var NumberInput = react_2.default.forwardRef(function (_a, ref) {
    var step = _a.step, min = _a.min, max = _a.max, props = __rest(_a, ["step", "min", "max"]);
    var internalRef = react_use_1.useEnsuredForwardedRef(ref);
    var theme = react_1.useTheme();
    var increment = function () {
        if (internalRef.current) {
            internalRef.current.stepUp();
            /*
              manually triggering an event because changing value in ref
              (calling stepUp) does not seem to trigger onChange
            */
            internalRef.current.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };
    var decrement = function () {
        if (internalRef.current) {
            internalRef.current.stepDown();
            /*
              manually triggering an event because changing value in ref
              (calling stepDown) does not seem to trigger onChange
            */
            internalRef.current.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };
    var inputProps = react_2.useMemo(function () { return (__assign({ step: step,
        min: min,
        max: max }, props.inputProps)); }, [props.inputProps, step, min, max]);
    var style = react_2.useMemo(function () { return styles_1.getStyle(props.disabled || false); }, [props.disabled]);
    var beforeNode = null;
    var afterNode = null;
    if (theme.name !== constant_1.DESIGN_SYSTEM) {
        beforeNode = (react_1.jsx(Before, { onClick: !props.disabled ? decrement : undefined, disabled: props.disabled }));
        afterNode = (react_1.jsx(After, { onClick: !props.disabled ? increment : undefined, disabled: props.disabled }));
    }
    else {
        var controlSize = props.size === 'small' ? 'small' : 'default';
        afterNode = (react_1.jsx(layout_1.Flex, { direction: "column", className: "buttonGroup", css: {
                height: props.size === 'small' ? 28 : 40,
                width: 22,
            } },
            react_1.jsx(Up, { onClick: !props.disabled ? increment : undefined, disabled: props.disabled, size: controlSize }),
            react_1.jsx(Down, { onClick: !props.disabled ? decrement : undefined, disabled: props.disabled, size: controlSize })));
    }
    return (react_1.jsx(Input_1.default, __assign({ before: beforeNode, after: afterNode, ref: internalRef, type: "number", centered: theme.name === constant_1.DESIGN_SYSTEM ? false : true }, props, { inputProps: inputProps, css: style.input })));
});
exports.default = Object.assign(NumberInput, {
    Labeled: withLabel_1.withLabel(NumberInput),
});
